import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mvp/MVPPageClient.jsx");
